import { validateConfigurations } from 'utils';
import {
  ContextActionTypes,
  ContextState,
  FETCH_CONTEXT_FULFILLED,
  FETCH_CONTEXT_REJECTED,
} from './types';

const initialState: ContextState = {
  posContext: {
    configurations: {
      environmentUrl: '',
      locationId: '',
      programId: '',
    },
    device: {
      hasScanner: false,
    },
    employee: {},
  },
  isPending: true,
  error: undefined,
};

export function contextReducer(
  state = initialState,
  action: ContextActionTypes
): ContextState {
  switch (action.type) {
    case FETCH_CONTEXT_FULFILLED:
      const validatedConfigurations = validateConfigurations(
        action.payload.posContext.configurations
      );
      return {
        ...state,
        posContext: {
          ...action.payload.posContext,
          configurations: validatedConfigurations,
        },
        isPending: false,
        error: undefined,
      };

    case FETCH_CONTEXT_REJECTED:
      return {
        ...state,
        isPending: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
